export default "__VITE_ASSET__BRXim1Fv__"